import { Pipe, PipeTransform } from '@angular/core';
import { dynamicMask } from '@app/utils';

@Pipe({ name: 'dynamicMask' })
export class DynamicMaskPipe implements PipeTransform {
    transform(
        value: string | null,
        baseMask: string = '',
        isHispano: boolean = false
    ): string {
        if (!value) return '';

        const digits = value.replace(/\D/g, '');
        const mask = dynamicMask(value, baseMask, isHispano) || '';

        let i = 0;
        return [...mask]
            .filter(() => i < digits.length)
            .map((char) => (char === '0' ? digits[i++] : char))
            .join('');
    }
}
